import React, { useState, useEffect, useCallback } from 'react'
import { Form } from 'react-bootstrap'
import { useAllMainSiteContent } from '../../../../../api/main-site-content/main-site-content.hooks'
import Select from 'react-select'

/**
 * Normalizes a page name for display purposes
 * Converts "kebab-case" to "Title Case"
 * Example: "soon-valley" -> "Soon Valley"
 */
const normalizePageNameForDisplay = (pageName) => {
  if (!pageName || typeof pageName !== 'string') {
    return ''
  }
  return pageName
    .replace(/-/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase())
}

const DistrictSelector = ({ onSelectionChange, initialSelection = null }) => {
  const [selectedDistrict, setSelectedDistrict] = useState(null)
  const [hasInitialized, setHasInitialized] = useState(false)

  const {
    content: apiContent,
    isLoading,
    refetch,
  } = useAllMainSiteContent({ type: "attractions-by-destination" })

  // Initialize selection from props when apiContent is loaded or when initialSelection changes
  useEffect(() => {
    if (!isLoading && apiContent) {
      if (initialSelection) {
        const district = apiContent.find(item => item._id === initialSelection)
        if (district) {
          setSelectedDistrict({
            value: district._id,
            label: normalizePageNameForDisplay(district.pageName)
          })
        } else {
          // District not found, clear selection
          setSelectedDistrict(null)
        }
      } else {
        // No initial selection, clear selection
        setSelectedDistrict(null)
      }
      if (!hasInitialized) {
        setHasInitialized(true)
      }
    }
  }, [initialSelection, apiContent, isLoading, hasInitialized])

  // Notify parent component of changes (but not during initial load)
  useEffect(() => {
    if (onSelectionChange && hasInitialized) {
      onSelectionChange(selectedDistrict?.value || null)
    }
  }, [selectedDistrict, hasInitialized, onSelectionChange])

  // Format options for react-select
  const districtOptions = apiContent?.map(district => ({
    value: district._id,
    label: normalizePageNameForDisplay(district.pageName)
  })) || []

  const handleDistrictChange = useCallback((selectedOption) => {
    setSelectedDistrict(selectedOption)
  }, [])

  if (isLoading) {
    return (
      <Form.Group className='mb-3'>
        <Form.Label>District</Form.Label>
        <div>Loading districts...</div>
      </Form.Group>
    )
  }

  return (
    <Form.Group className='mb-3'>
      <Form.Label>District</Form.Label>
      <Select
        value={selectedDistrict}
        onChange={handleDistrictChange}
        options={districtOptions}
        placeholder="Select a district..."
        isClearable
        isSearchable
      />
    </Form.Group>
  )
}

export default DistrictSelector